import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=572d756c&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=572d756c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d756c",
  null
  
)

component.options.__file = "sidebar.vue"
export default component.exports